import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import data from '../../utils/data';
import ReactModal from 'react-modal';
import {Validators, FormBuilder, FieldControl, FieldGroup} from 'react-reactive-form';
import renderers from './forms/renderers';
import ArrayEditControl from './forms/ArrayEditControl';
import LocationEditControl from './forms/LocationEditControl';
import LinkEditControl from './forms/LinkEditControl';
import LanguageFieldsEditControl from './forms/LanguageFieldsEditControl';
import IdentifiersEditControl from './forms/IdentifiersEditControl';

class UpdateProgress extends Component {
    render() {
        return (
            <span className="kbedit-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Updating ...
            </span>
        );
    }
}

class KbEditThingDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onScrollTo = this.onScrollTo.bind(this);
        this.updateHeightDimensions = this.updateHeightDimensions.bind(this);

        this.state = {
            height: 0,
            modalOpen: false,
            error: null,
            updating: false,
            data: null,
            isProduct: false,
            isThing: true
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_KbEditThingDialog');
        if (this.props.id) {
            this.updateHeightDimensions();
            this.open();
        }
    }

    componentWillUnmount() {
    }

    updateHeightDimensions() {
        this.setState({
            height: window.innerHeight - 75 - (window.innerHeight / 5)
        })
    }

    close(resp=null) {
        this.setState({
            modalOpen: false,
            updating: false,
            error: null
        }, () => {
            if (this.myForm) {
                this.myForm.get('subType').onValueChanges.unsubscribe();
                this.myForm.get('type').onValueChanges.unsubscribe();
            }
            if (this.props.onClose) {
                this.props.onClose(resp);
            }
        })
    };

    open() {
        if (this.props.id) {
            urlHandler.sendRequest('entities2', null, this.props.id, null, null, (resp,txt,status) => {
                if (status == 200) {
                    this.myForm = FormBuilder.group({
                        label: [resp.label ? resp.label : '', Validators.required],
                        type: [resp.type ? resp.type : 'THING',[Validators.required, Validators.pattern(validation.customTypePattern),Validators.minLength(2)]],
                        description: [resp.description ? resp.description : '', Validators.required],
                        prominence: [resp.prominence ? resp.prominence : 0.00, Validators.required],
                        subType: [resp.subType ? resp.subType : 'THING', [Validators.required, Validators.pattern(validation.customTypePattern),Validators.minLength(2)]],
                        productType: [resp.productType ? resp.productType : 'AIRCRAFT'],
                        nameVariations: FormBuilder.array(ArrayEditControl.initArray(resp.nameVariations), {validators: [Validators.required]}),
                        brand: [resp.brand ? resp.brand : ''],
                        series: [resp.series ? resp.series : ''],
                        chemicalFormula: [resp.chemicalFormula ? resp.chemicalFormula : ''],
                        casNumber: [resp.casNumber ? resp.casNumber : ''],
                        releaseDate: [resp.releaseDate ? resp.releaseDate : '', Validators.pattern(validation.datePattern)],
                        discontinuedDate: [resp.discontinuedDate ? resp.discontinuedDate : '', Validators.pattern(validation.datePattern)],
                        urls: FormBuilder.array(ArrayEditControl.initArray(resp.urls, [Validators.pattern(validation.urlPattern)])),
                        imageUrls: FormBuilder.array(ArrayEditControl.initArray(resp.imageUrls, [Validators.pattern(validation.urlPattern)])),
                        uses: FormBuilder.array(ArrayEditControl.initArray(resp.uses)),  
                        follows: FormBuilder.array(ArrayEditControl.initArray(resp.follows)),  
                        followedBy: FormBuilder.array(ArrayEditControl.initArray(resp.followedBy)),                    
                        countries: FormBuilder.array(ArrayEditControl.initArray(resp.countries)),
                        categories: FormBuilder.array(ArrayEditControl.initArray(resp.categories)),
                        contextKeywords: FormBuilder.array(ArrayEditControl.initArray(resp.contextKeywords)),
                        languageFields: FormBuilder.array(LanguageFieldsEditControl.initArray(resp.languageFields)),
                        identifiers: FormBuilder.array(IdentifiersEditControl.initArray(resp.identifiers)),
                        manufacturers: FormBuilder.array(LinkEditControl.initArray(resp.manufacturers)),
                        operators: FormBuilder.array(LinkEditControl.initArray(resp.operators)),
                        designers: FormBuilder.array(LinkEditControl.initArray(resp.designers)),
                        developers: FormBuilder.array(LinkEditControl.initArray(resp.developers)),
                        powerPlants: FormBuilder.array(LinkEditControl.initArray(resp.powerPlants)),
                        userData: [resp.userData ? JSON.stringify(resp.userData) : ''],
                        document: [resp.document ? resp.document : '', [Validators.minLength(250)]]
                    });

                    this.myForm.get('subType').onValueChanges.subscribe((value) => {
                        this.setState({
                            isProduct: (value && value === 'PRODUCT')
                        })                           
                    })

                    this.myForm.get('type').onValueChanges.subscribe((value) => {
                        this.setState({
                            isThing: (value && value === 'THING')
                        })                           
                    })

                    this.setState({
                        data: resp,
                        isProduct: (resp.subType && resp.subType === 'PRODUCT'),
                        isThing: (resp.type && resp.type === 'THING'),
                        modalOpen: true,
                        updating: false
                    })
                }
            });  
        } 
    };

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            updating: true
        }, ()=> {
            if (this.myForm.valid) {

                var objectData = Object.assign({}, this.state.data);
                var formValues = Object.assign({}, this.myForm.value);

                // Merge any data that is missing from the form values into the form.
                Object.keys(objectData).forEach(function(key) {
                    if (!(key in formValues)) {
                        formValues[key] = objectData[key];
                    }
                });

                // Sync to match THING or THING subtype which is shown in select as custom subtypes not supported for THING entities
                var subTypes = data.getThingSubTypes();
                if (formValues && formValues.type == 'THING' && !subTypes.includes(formValues.subType)){
                    formValues.subType = 'THING';
                }
                
                // Sync/remove productType field if subType is not Product
                if (formValues && formValues.subType !== 'PRODUCT'){
                    delete formValues['productType'];
                }

                // Sync the URL values with ID values. User doesn't see the ID values, only edits the URL values.
                validation.syncIdsWithUrls(formValues);

                // Remove all empty fields from the update object
                validation.removeEmptyItems(formValues);

                // The range slider editor will return string values when touched by the user. Not sure why? Convert back to float.
                if ('prominence' in formValues) {
                    formValues.prominence = parseFloat(formValues.prominence);
                }

                // Validate the user data is JSON
                if ('userData' in formValues && formValues.userData.length > 0) {
                    try {
                        formValues.userData = JSON.parse(formValues.userData);
                    } catch(ex) {
                        var msg = '';
                        if (ex instanceof SyntaxError) {
                            msg = 'SyntaxError: ' + ex.message;
                        } else {
                            msg = ex.message;                           
                        }
                        this.setState({
                            error: 'Invalid user data JSON value.\n' + msg,
                            updating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })
                        return;
                    }
                }

                urlHandler.sendKbUpdateRequest(this.props.id, formValues, (resp, status) => {
                    if (status != 200) {
                        let error = decodeURIComponent(resp.error_message)
                        error = (error === undefined || error === 'undefined') ? '' : error;
                        if (!error && status == 504) {
                            error ='FFT Gateway timed out. Contact your administrator. Please try again later.' 
                        }
                        else if(!error) {
                            error = 'There was an error updating the thing entity. Please try again later.';
                        }
                        this.setState({
                            error,
                            updating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })   
                    } else {
                        this.close(resp);
                    }
                })
            } else {
                this.setState({
                    error: 'There are errors below.',
                    updating: false
                }, () => {
                    this.onScrollTo('err_msg');
                })
            }
        });
    }

    onReset() {
        this.close();
    }

    onScrollTo(anchor) {
        document.getElementById(anchor).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    render() {
        var subTypes = data.getThingSubTypes();
        var productTypes = data.getProductTypes();
        var countries = data.getCountries();

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '70%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <div id="rm_KbEditThingDialog">
                <ReactModal ref="editId" 
                    isOpen={this.state.modalOpen}
                    contentLabel={this.props.name}
                    onRequestClose={this.close} 
                    style={styles}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="kbedit">
                        <div className="kbedit-header">
                            <span className="header-text">Edit {this.props.name}</span>
                        </div> 

                        <div className="kbedit-content" style={{maxHeight: `${this.state.height}px`}}>

                        <div className="kbedit-controls-wrapper">
                            <div className="kbedit-static-menu">
                                <span onClick={() => {this.onScrollTo('bm_thing_details')}}>Thing Details</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_identifiers')}}>Identifiers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_urls')}}>Urls</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_image_urls')}}>Image Urls</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_uses')}}>Uses</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_follows')}}>Follows</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_followed_by')}}>Followed By</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_manufacturers')}}>Manufacturers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_operators')}}>Operators</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_designers')}}>Designers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_developers')}}>Developers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_power_plants')}}>Power Plants</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_countries')}}>Countries</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_categories')}}>Categories</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_context_keywords')}}>Context Keywords</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_language_fields')}}>Language Fields</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_user_data')}}>User Data</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_document')}}>Document</span>
                            </div>

                            <div className="kbedit-controls-list">
                                {this.state.error &&
                                    <div className="kbedit-error" id="err_msg">
                                        {this.state.error}
                                    </div>
                                }

                                <FieldGroup
                                    control={this.myForm}
                                    render={({ pristine, value, invalid}) => (
                                        <div className="kbedit-nav-items">
                                            <div id="bm_thing_details">
                                                <FieldControl name='label' render={renderers.textBox} meta={{label: 'Label', placeholder: 'Enter name'}}/>
                                                <FieldControl name='description' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'Description', 
                                                        placeholder: 'Enter description',
                                                        height: '300px'
                                                    }}
                                                />
                                                <FieldControl name='type' render={renderers.textBox} meta={{label: 'Type', placeholder: 'Enter type (ONLY_USE_ALL_CAPS_AND_UNDERSCORE)'}}/>
                                                { this.state.isThing &&
                                                  <FieldControl name='subType' render={renderers.selectBox} meta={{label: 'Sub Type', items: subTypes}}/>
                                                }
                                                { !this.state.isThing && 
                                                    <FieldControl name='subType' render={renderers.textBox} meta={{label: 'Sub Type', items: subTypes}}/>
                                                }
                                                {this.state.isProduct &&
                                                    <FieldControl name='productType' render={renderers.selectBox} meta={{label: 'Product Type', items: productTypes}}/>
                                                }
                                                <FieldControl name='prominence' render={renderers.rangeSlider} meta={{label: 'News Prominence'}}/>
                                                <ArrayEditControl name='nameVariations' label='Name Variations' addLabel="Add name variation" form={this.myForm}/>
                                                <FieldControl name='brand' render={renderers.textBox} meta={{label: 'Brand', placeholder: 'Enter brand'}}/>
                                                <FieldControl name='series' render={renderers.textBox} meta={{label: 'Series', placeholder: 'Enter series'}}/>
                                                <FieldControl name='chemicalFormula' render={renderers.textBox} meta={{label: 'Chemical Formula', placeholder: 'Enter formula'}}/>
                                                <FieldControl name='casNumber' render={renderers.textBox} meta={{label: 'CAS Registry Number', placeholder: 'Enter cas number'}}/>
                                                <FieldControl name='releaseDate' render={renderers.textBox} meta={{label: 'Release Date', placeholder: 'YYYY-MM-DD'}}/>
                                                <FieldControl name='discontinuedDate' render={renderers.textBox} meta={{label: 'Discontinued Date', placeholder: 'YYYY-MM-DD'}}/>                                                                                                              
                                            </div>
                                            <div id="bm_identifiers">
                                                <IdentifiersEditControl name="identifiers" label="Identifiers" addLabel="Add identifier" form={this.myForm}/>
                                            </div>
                                            <div id="bm_urls">
                                                <ArrayEditControl name='urls' label='Urls' 
                                                    addLabel="Add url" 
                                                    form={this.myForm} 
                                                    itemValidators={[Validators.pattern(validation.urlPattern)]}
                                                />
                                            </div>
                                            <div id="bm_image_urls">
                                                <ArrayEditControl name='imageUrls' 
                                                    label='Image Urls' 
                                                    addLabel="Add image url" 
                                                    form={this.myForm} 
                                                    itemValidators={[Validators.pattern(validation.urlPattern)]}
                                                    image={true}
                                                />
                                            </div>
                                            <div id="bm_uses">
                                                <ArrayEditControl name='uses' label='Uses' addLabel="Add use" form={this.myForm}/>
                                            </div>
                                            <div id="bm_follows">
                                                <ArrayEditControl name='follows' label='Follows' addLabel="Add follow" form={this.myForm}/>
                                            </div>
                                            <div id="bm_followed_by">
                                                <ArrayEditControl name='followedBy' label='Followed By' addLabel="Add followed by" form={this.myForm}/>
                                            </div>
                                            <div id="bm_manufacturers">
                                                <LinkEditControl name="manufacturers" label="Manufacturers" addLabel="Add manufacturer" form={this.myForm}/>
                                            </div>
                                            <div id="bm_operators">
                                                <LinkEditControl name="operators" label="Operators" addLabel="Add operator" form={this.myForm}/>
                                            </div>
                                            <div id="bm_designers">
                                                <LinkEditControl name="designers" label="Designers" addLabel="Add designer" form={this.myForm}/>
                                            </div>
                                            <div id="bm_developers">
                                                <LinkEditControl name="developers" label="Developers" addLabel="Add developer" form={this.myForm}/>
                                            </div>
                                            <div id="bm_power_plants">
                                                <LinkEditControl name="powerPlants" label="Power Plants" addLabel="Add power plant" form={this.myForm}/>
                                            </div>
                                            <div id="bm_countries">
                                                <ArrayEditControl name="countries" 
                                                    label="Countries" 
                                                    addLabel="Add country" 
                                                    form={this.myForm} 
                                                    items={countries}
                                                    itemsEditable={true}/>
                                            </div>
                                            <div id="bm_categories">
                                                <ArrayEditControl name='categories' label='Categories' addLabel="Add category" form={this.myForm}/>
                                            </div>
                                            <div id="bm_context_keywords">
                                                <ArrayEditControl name='contextKeywords' label='Context Keywords' addLabel="Add keyword" form={this.myForm} expanded={false}/>
                                            </div>
                                            <div id="bm_language_fields">
                                                <LanguageFieldsEditControl name="languageFields" label="Language Fields" addLabel="Add language field" form={this.myForm}/>
                                            </div>
                                            <div id="bm_user_data">
                                                <FieldControl name='userData' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'User Data (Valid JSON)', 
                                                        placeholder: 'Enter JSON',
                                                        height: '300px',
                                                        monospace: true,
                                                        expanded: false
                                                    }}
                                                />
                                            </div>
                                            <div id="bm_document">
                                                <FieldControl name='document' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'Document', 
                                                        placeholder: 'Enter document',
                                                        height: '500px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        
                        </div>
                        <div className="kbedit-footer">
                            {this.state.updating ? <UpdateProgress /> : null}
                            <button type="button" className="kbedit-default-button" onClick={this.onSubmit}>Save</button>
                            <button type="button" className="kbedit-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

KbEditThingDialog.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func
};

export default KbEditThingDialog;

export function kbEditThingDialog(name, id, callback) {
    
    var divTarget = document.getElementById('react-kbeditthing-dialog')

    var close = (ans) => {
        if (divTarget) {
            ReactDOM.unmountComponentAtNode(divTarget);
        }
        if (callback) {
            callback(ans);
        }
    }

    if (divTarget) {
        ReactDOM.render(<KbEditThingDialog name={name} id={id} onClose={close}/>, divTarget);
    } else {
        divTarget = document.createElement('div')
        divTarget.id = 'react-kbeditthing-dialog'
        document.body.appendChild(divTarget)
        ReactDOM.render(<KbEditThingDialog name={name} id={id} onClose={close}/>, divTarget);
    }
 }



